import * as React from "react";
import CustomModal from "./CustomModal";

// Confirmación con el formato de ModalPopUp de aedas-library: texto centrado,
// "Cancelar" (secundario) y la acción (primario)
type ConfirmModalProps = {
  show: boolean;
  title: React.ReactNode;
  message: React.ReactNode;
  confirmLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
  disabled?: boolean; // mientras se ejecuta la acción
};

export default function ConfirmModal(props: ConfirmModalProps) {
  const { show, title, message, confirmLabel, onConfirm, onCancel, disabled } = props;
  return (
    <CustomModal
      size="lg"
      show={show}
      onChange={onCancel}
      title={title}
      body={<p className="paragraph-text aedasModal__text">{message}</p>}
      buttons={[
        { content: "Cancelar", primary: false, action: onCancel },
        { content: confirmLabel, primary: true, action: onConfirm, disabled },
      ]}
    />
  );
}
